import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageComponent } from "../../../components/language/language.component";
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    TranslateModule,
    LanguageComponent,
    MatTooltipModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {

  valid: boolean = true;
  toggled: boolean = true;
  type: string = 'password';
  lang = 'en';
  loginForm = new FormGroup({
    email: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
  });

  images: { src: string, description: string }[] = [
    { src: 'imgLogin2.png', description: '5K0 SMART' },
    { src: 'imgLogin3.png', description: '5K3 XP' },
    { src: 'imgLogin4.png', description: 'A-KOOL' },
    { src: 'imgLogin5.png', description: 'A-KOOL' },
    { src: 'imgLogin6.png', description: 'ESY' },
    { src: 'imgLogin7.png', description: 'HYBO' }
  ]

  constructor(private router: Router,
    private authService: AuthService) {
    this.shuffle();
  }

  ngOnInit(): void {
  }

  shuffle() {
    let currentIndex = this.images.length, randomIndex;

    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      [this.images[currentIndex], this.images[randomIndex]] = [
        this.images[randomIndex], this.images[currentIndex]
      ];
    }
  }

  async login() {
    //try {
    await this.authService.loginUser(
      this.loginForm.get('email')?.value!,
      this.loginForm.get('password')?.value!);
    if (this.authService.getToken() != null) {
      this.router.navigate(['/systemsList']);
    }

    // } catch (error) {
    //   console.error('Login failed', error);
    // }
  }

  seePassword() {
    if (this.type === 'password') {
      this.type = 'text';
      this.toggled = false;
    }
    else {
      this.type = 'password';
      this.toggled = true;
    }
  }

  changeLang(lang: string) {
    this.lang = lang;
  }

}

